import reducer from './ducks/reducer'

export default reducer
